import Hero from "../components/Hero";
import ProductCarousel from "../components/ProductCarousel";
import About from "../components/About";
import Products from "../components/Products";
import WhyUs from "../components/WhyUs";
import Certifications from "../components/Certifications";
import TrustCompliance from "../components/TrustCompliance";
import Gallery from "../components/Gallery";
import GlobalMap from "../components/GlobalMap";
import MarketsStrip from "../components/MarketsStrip";
import Inquiry from "../components/Inquiry";
import { useSEO } from "../lib/seo";

export default function Home() {
    useSEO({
        title: "RP Traders — Premium Indian Spices Exporter from Guntur, Andhra Pradesh",
        description:
            "Indian spices and agro commodities exporter from Guntur. Premium red chilli, Guntur Teja, turmeric, coriander, cumin and Indian spices supplied to UAE, Saudi Arabia, Netherlands, USA, UK and 30+ countries.",
        keywords:
            "Indian spices exporter, Red chilli exporter from India, Guntur chilli exporter, Turmeric exporter from India, Coriander exporter India, Cumin exporter India, Spice exporter to UAE, Spice exporter to Netherlands, Bulk spice supplier India, Agro commodities exporter India",
    });
    return (
        <>
            <Hero />
            <MarketsStrip />
            <ProductCarousel />
            <About />
            <Products />
            <WhyUs />
            <TrustCompliance />
            <Certifications />
            <Gallery />
            <GlobalMap />
            <Inquiry />
        </>
    );
}
